module.exports = __webpack_public_path__ + "static/media/calendar.e8cfa6ed.svg";